import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import './PaymentMethodPage.scss';

export class PaymentMethodPage extends Component {
  render() {
    const title = "What is the method of payment?";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "icon-button-order",
        inputs: [
          {
            type: 'icon-button',
            id: "insurance-method",
            className: "btn--icon btn--insurance",
            icon: "insurance",
            value: "Insurance",
            onClick: () => {
              this.props.webAppointmentSetPaymentMethod("insurance");
              this.props.history.push(nextPage(null, { paymentMethod: "insurance" }));
            }
          },
          {
            type: 'icon-button',
            id: "out-of-pocket-method",
            className: "btn--icon btn--out-of-pocket",
            icon: "out-of-pocket",
            value: 'Out-of-pocket',
            onClick: () => {
              this.props.webAppointmentSetPaymentMethod("out-of-pocket");
              this.props.history.push(nextPage(null, { paymentMethod: "out-of-pocket" }));
            }
          },
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--secondary",
            value: 'Back',
            onClick: () => {
              this.props.history.goBack();
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

PaymentMethodPage.propTypes = {
  webAppointmentSetPaymentMethod: PropTypes.func.isRequired,
  paymentMethod: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  return {
    paymentMethod: state.webAppointmentForm.paymentMethod
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetPaymentMethod: (value) => dispatch(webAppointmentActions.webAppointmentSetPaymentMethod(value)),
  };
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentMethodPage));
